import React from "react";
import PropTypes from "prop-types";

import iconArrowRight from './icon-arrow-right.svg'
import iconArrowLeft from './icon-arrow-left.svg'

import './style.css'

const Pagination = (props) => {
    const { inOffset, inLimit, data, showNext, total, className } = props;

    const pages = Math.ceil(total/inLimit)

    return (

        data.length ?
        <div className={`${className} hsg-component-pagination-root`}>
            <button
                onClick={() => (inOffset === 0 ? null : showNext("prev"))}
                className={`hsg-btn-white hsg-component-pagination-button ${inOffset === 0 ? 'hsg-component-pagination-no-action' : ''}`}
            >
                <img src={iconArrowRight}/>
                {/* <span aria-hidden="true" data-icon="&#e906;" className="icon-previous"></span> */}
            </button>
            <div className="hsg-component-pagination-page">
                <span className="hsg-component-pagination-page-on">
                    {inOffset || 0 + 1}
                    {"-" + ((inOffset || 0) + data.length)}
                </span>
                {" of " + total}
            </div>
            <button
                onClick={() => (total - inOffset <= data.length ? null : showNext("next"))}
                className={`hsg-btn-white hsg-component-pagination-button ${total - inOffset <= data.length ? 'hsg-component-pagination-no-action' : ''}`}
            >

                <img src={iconArrowLeft}/>
                {/* <span aria-hidden="true" data-icon="&#e908;" className="icon-next"></span> */}
            </button>
        </div> : null
    );
};

export default Pagination;

Pagination.propTypes = {
    data: PropTypes.array.isRequired,
    total: PropTypes.number.isRequired,
    className: PropTypes.string.isRequired,
    showNext: PropTypes.func.isRequired,
};
